import React, {Fragment} from 'react'
import MainLayout from '../../components/Layout/MainLayout'

import ProfileSidebar from '../../components/Profile/Leftbar'
import {LocalStore} from "../../utils/LocalStore";

import {
    Row, Col, notification, Collapse, Table, Checkbox, Tooltip, Spin
} from 'antd';
import * as AntdIcon from "@ant-design/icons"
import {withNamespaces} from "react-i18next";
import NotificationServices from "../../services/notifications.service";

const Panel = Collapse.Panel;

let currentLoggedUser = null;
class NotificationConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeNotification: 0,
            listNotification: [],
            eventsSetting:[]
        }
    }

    componentWillMount() {
        // Hủy sự kiện cảnh báo khi load trang
        window.onbeforeunload = null;

        if (typeof LocalStore.getInstance().read('currentLoggedUser') === 'object') {
            currentLoggedUser = LocalStore.getInstance().read('currentLoggedUser') || {};

            this.setState({isLoading: true}, () => {
                this.getNotificationChannel();
                this.getEventSettings();
                this.getNotificationEvents();
                this.getNotificationEventGroups()
            });
        }
    }

    getListNotificationSetting = (cb) => {
        const {events} = this.state;


        this.setState({showProgressBar: true}, () => {

            NotificationServices.getNotificationSettings((err, res) => {
                if (!err) {
                    let current = null;
                    let state = {};
                    if (Array.isArray(res)) {
                        res.map(item => {
                            current = events.find(x => x.eventCode === item.eventCode);

                            if (current && item.web) {
                                if (Array.isArray(state[`${current.groupCode}_${'web'}_listSelected`])) {
                                    state[`${current.groupCode}_${'web'}_listSelected`].push(current)
                                } else {
                                    state[`${current.groupCode}_${'web'}_listSelected`] = [current]
                                }
                            }

                            if (current && item.zalo) {
                                if (Array.isArray(state[`${current.groupCode}_${'zalo'}_listSelected`])) {
                                    state[`${current.groupCode}_${'zalo'}_listSelected`].push(current)
                                } else {
                                    state[`${current.groupCode}_${'zalo'}_listSelected`] = [current]
                                }
                            }

                            if (current && item.email) {
                                if (Array.isArray(state[`${current.groupCode}_${'email'}_listSelected`])) {
                                    state[`${current.groupCode}_${'email'}_listSelected`].push(current)
                                } else {
                                    state[`${current.groupCode}_${'email'}_listSelected`] = [current]
                                }
                            }

                            if (current && item.telegram) {
                                if (Array.isArray(state[`${current.groupCode}_${'telegram'}_listSelected`])) {
                                    state[`${current.groupCode}_${'telegram'}_listSelected`].push(current)
                                } else {
                                    state[`${current.groupCode}_${'telegram'}_listSelected`] = [current]
                                }
                            }
                        });

                        this.setState({...state})
                    }

                }
                if(cb) cb();
                this.setState({showProgressBar: false, isLoading: false})
            });
        });
    };

    getNotificationChannel = (cb) => {
        this.setState({showProgressBar: true}, () => {
            NotificationServices.getNotificationChannel((err, res) => {
                if (!err) {
                    this.setState({channels: res})
                } else {
                    this.setState({isLoading: false, showProgressBar: true})
                }
            });
        });
    };

    getEventSettings = () => {
        this.setState({showProgressBar: true}, () => {
            NotificationServices.getEventSettings((err, res) => {
                if (!err) {
                    this.setState({eventsSetting: res})
                } else {
                    this.setState({isLoading: false, showProgressBar: true})
                }
            });
        });
    };


    getNotificationEvents = (cb) => {
        this.setState({showProgressBar: true}, () => {
            NotificationServices.getNotificationEvents((err, res) => {
                if (!err) {
                    this.setState({events: res}, () => {
                        this.getListNotificationSetting();
                    })
                } else {
                    this.setState({isLoading: false, showProgressBar: true})
                }
            });
        });
    };

    getNotificationEventGroups = (cb) => {
        this.setState({showProgressBar: true}, () => {
            NotificationServices.getNotificationEventGroups((err, res) => {
                if (!err) {
                    this.setState({eventGroups: res})
                } else {
                    this.setState({isLoading: false, showProgressBar: true})
                }
            });
        });
    };

    /**
     * check all Email
     * @param e
     * @param groupCode
     * @param channelCode
     */
    onCheckAll = (e, groupCode, channelCode) => {
        let {events = [], channels = [], eventGroups = []} = this.state;

        // console.log('onCheckAll', groupCode, channelCode);

        const currentEvents = events.filter(x => x.groupCode === groupCode);

        this.setState({
            [`${groupCode}_${channelCode}_listSelected`]: e.target.checked ? currentEvents : [],
            [`${groupCode}_${channelCode}_indeterminate`]: false,
            [`${groupCode}_${channelCode}_checkAll`]: e.target.checked,
        });
    };

    /**
     * receive notification via Email
     * @param item
     * @param groupCode
     * @param channelCode
     */
    onChangeItem = (groupCode, channelCode, item) => {
        let {events = [], channels = [], eventGroups = []} = this.state;
        const currentEvents = events.filter(x => x.groupCode === groupCode);
        let currentListSelected = this.state[`${groupCode}_${channelCode}_listSelected`] || [];

        let value = false;

        if (Array.isArray(currentListSelected) && currentListSelected.find(x => x.eventCode === item.eventCode)) {
            currentListSelected = currentListSelected.filter(x => x.eventCode !== item.eventCode)
        } else {
            currentListSelected.push(item);
            value = true
        }

        this.setState({
            [`${groupCode}_${channelCode}_listSelected`]: currentListSelected,
            [`${groupCode}_${channelCode}_indeterminate`]: !!currentListSelected.length && (currentListSelected.length < currentEvents.length),
            [`${groupCode}_${channelCode}_checkAll`]: currentListSelected.length === currentEvents.length,
        }, () => {
            this.onSubmitNotification(groupCode, channelCode, item, value)
        })
    };

    /**
     * submit notification config
     */
    onSubmitNotification = (groupCode, channelCode, item, value) => {
        let {t} = this.props;
        let {confirmLoading} = this.state;

        let body = {
            eventCode: item.eventCode,
            [channelCode]: value
        };

        if (confirmLoading) return;
        this.setState({confirmLoading: true}, () => {
            //Thực hiện đẩy dữ liệu và call api
            NotificationServices.addNotificationSettings(body, (err, res) => {
                if (!err) {
                    notification['success']({
                        message: t('message.success'),
                    });
                    this.setState({confirmLoading: false});
                } else {
                    notification['error']({
                        message: t(err.message),
                    });

                }
            });
        });

    };

    /**
     * render header của panel
     * @param item
     */
    renderPanelHeader = (item) => {
        const {t} = this.props;
        return (
            <div className={`panel-notification-header _notificationTitle`}>
                <span className='txt-color-black txt-size-h8 pdr5 txt-uppercase bold'>{item.name}</span>
                <Tooltip placement="top" title={item.name}>
                    <AntdIcon.QuestionCircleOutlined type="question-circle" theme="filled"  className={'txt-size-h8 txt-color-gray opacity6'}/>
                </Tooltip>
            </div>
        )
    };

    renderGroupNotification = (item, index) =>{
        // console.log(item);
        const {events = [], eventsSetting} = this.state;
        const temp = events.filter(x => x.groupCode === item.code);
        let currentEvents=[];
        temp.map(x=>{
                let eventSetting = eventsSetting.find(xx=> xx.eventCode===x.eventCode);
                if(eventSetting&&eventSetting.channels&&eventSetting.channels.length>0){
                    currentEvents.push({...x, channelsSetting: eventSetting.channels});
                }
        });
        if(currentEvents.length===0) return;
        return  <Panel className={'bg-color-gray'} header={this.renderPanelHeader(item)} key={index}>
            {this.renderContentNotification(item, currentEvents)}
        </Panel>
    }
    /**
     * render content notification
     * @return {*}
     */
    renderContentNotification = (item,currentEvents) => {
        const {channels = []} = this.state;
        const columns = [{
            dataIndex: 'name',
            key: 'name',
            className: 'bg-color-white _notification-name',
            render: (text, record) => {
                return (
                    <span className="_financial-type-detail vertical-align-middle txt-size-h7 break-word txt-color-black roboregular mgbt5 ">{text}</span>
                )
            }
        }];

        channels.map((x, y) => {
            columns.push({
                title: ()=> <Fragment>
                    {/*<Checkbox*/}
                        {/*checked={this.state[`${item.code}_${x.channel}_checkAll`]}*/}
                        {/*indeterminate={this.state[`${item.code}_${x.channel}_indeterminate`]}*/}
                        {/*onChange={(e) => this.onCheckAll(e, item.code, x.channel)}*/}
                    {/*/>*/}
                    <span className='txt-size-h7 txt-color-black bold'>{x.name}</span>
                </Fragment>,
                dataIndex: x.channel,
                key: x.channel,
                className: `bg-color-white  _notification_listcheck table__name`,
                render: (text, record) => (
                    <Checkbox
                        disabled={!record.channelsSetting.includes(x.channel)}
                         checked={record.channelsSetting.includes(x.channel)&&Array.isArray(this.state[`${item.code}_${x.channel}_listSelected`]) && !!this.state[`${item.code}_${x.channel}_listSelected`].find(i => i.eventCode === record.eventCode)}
                         onChange={() => this.onChangeItem(item.code, x.channel, record)}
                    />
                ),
            })
        });

        return (
            <Table
                className={'_notification-table pdl10 table-settings-notification'}
                rowKey={(record, index) => index}
                columns={columns}
                dataSource={ currentEvents || []}
                rowClassName={() => `_notification-row`}
                pagination={{
                    hideOnSinglePage: true,
                    simple: true,
                    pageSize: Array.isArray(currentEvents) ? currentEvents.length : 0
                }}
            />
        )
    };

    render() {
        const {activeNotification, confirmLoading, isLoading, eventGroups = [], eventsSetting} = this.state;
        const {t} = this.props;
        return <MainLayout
            {...this.props}
            showProgressBar={this.state.showProgressBar}
            headerTitle={t('userProfile.notification_config')}
            title={t('userProfile.notification_config')}
        >
            <div className={'container pdbt30 pdt20 mgr20'}>
                <Row>
                    <Col span={6} className={'pdr20'}>
                        <ProfileSidebar currentRoute={'notification'}/>
                    </Col>
                    <Col span={18} className={'pd20 bg-color-white'}>
                        <h3 className='txt-color-gray txt-size-h7 pdbt10'>{t('userProfile.notification_config_des')}</h3>

                        {
                            isLoading ?
                                <div className="dpl-flex align-items-center justify-content pdt30 pdbt30">
                                    <Spin indicator={<AntdIcon.Loading3QuartersOutlined type="loading" style={{ fontSize: 24 }} spin />} />
                                </div>
                                :
                                <Spin spinning={confirmLoading === true} indicator={<AntdIcon.Loading3QuartersOutlined type="loading" style={{ fontSize: 24 }} spin />} >
                                    <Collapse
                                        accordion
                                        activeKey={[`${activeNotification}`]}
                                        className='sidebar position-re'
                                        onChange={(e) => {
                                            this.setState({activeNotification: e});
                                        }}
                                    >
                                        {
                                            eventGroups.map((item, index) => this.renderGroupNotification(item,index))
                                        }
                                    </Collapse>
                                </Spin>
                        }
                    </Col>

                </Row>
            </div>
        </MainLayout>;
    }
}
export default withNamespaces()(NotificationConfig);
